import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import _ from "lodash";
import moment from "moment";
import { getSensorData, filteredSensorDataList, modalAlert } from "../../_actions";
import Plot from "react-plotly.js";
import "./index.css";

const alertingColors = {
  info: "green",
  warning: "orange",
  critical: "red",
  reportable: "#900C3F"
};

class LineGraph extends Component {
  constructor(props) {
    super(props);

    let maxRecords = 10000;
    let seriesIndex = 1;

    if (props.maxRecords !== undefined) {
      maxRecords = props.maxRecords;
    }

    if (props.seriesIndex !== undefined) {
      seriesIndex = props.seriesIndex;
    }

    this.state = {
      time: 0,
      maxRecords: maxRecords,
      seriesIndex: seriesIndex
    };
  }

  componentDidMount = () => {
    if (this.props.refreshInterval) {
      this.interval = setInterval(() => {
        if (this.props.id !== undefined && this.props.sidebarOnFlag) {
          this.updateGraphData();
        }
        this.setState({ time: Date.now() });
      }, this.props.refreshInterval);
    }

    if (this.props.id !== undefined && this.props.sidebarOnFlag && !this.props.isDetailPage) {
      this.updateGraphData();
    }
  };

  componentWillReceiveProps = () => {
    if (this.props.id !== undefined && this.props.sidebarOnFlag) {
      //this.updateGraphData();
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.interval);
  };

  getAlertListForThisDevice = () => {
    const startDate = new Date(this.props.sensorDataList[0].start_time);
    const endDate = new Date(this.props.sensorDataList[0].end_time);

    const params = {
      devices: this.props.id,
      start_time: startDate.toISOString(),
      end_time: endDate.toISOString()
    };
    const url = "/api/v1/alerts/";
    const errorMsg = "Unable to get alerts for this device.";

    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      this.setState(() => {
        return {
          alertsListForThisDevice: json.results
        };
      });
    });
  };

  /* Method to update the graph data based on time interval */
  updateGraphData = () => {
    const today = new Date();
    const initialStartDate = new Date(new Date().setDate(today.getDate() - 1));

    const params = {
      start_time: initialStartDate.toISOString(),
      end_time: today.toISOString(),
      max_records: this.state.maxRecords
    };

    const url = "/api/v1/devices/" + this.props.id + "/telemetry/";
    const errorMsg = "Unable to update the graph data.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      const tmpFilteredData = [];
      tmpFilteredData.push(
        json.telemetry_sets[0].columns[0],
        json.telemetry_sets[0].columns[this.props.seriesIndex + 1]
      );
      this.props.filteredSensorDataList(tmpFilteredData);
      this.props.getSensorData(json.telemetry_sets);
    });
  };

  getXmin = isItTruncated => {
    let tempXMin = null;

    if (isItTruncated) {
      tempXMin = this.props.list[0].rows[0];
    } else {
      tempXMin = this.props.list[0].plotting_advice.min;
    }

    return new Date(tempXMin).getTime();
  };

  getXmax = () => {
    let tempXMax = null;
    tempXMax = this.props.list[0].plotting_advice.max;
    return new Date(tempXMax).getTime();
  };

  getYmin = () => {
    if (!this.props.list[1]) {
      return null;
    }
    let tempYMin = null;
    tempYMin = this.props.list[1].plotting_advice.min;
    return tempYMin;
  };

  getYmax = () => {
    if (!this.props.list[1]) {
      return null;
    }
    let tempYMax = null;
    tempYMax = this.props.list[1].plotting_advice.max;
    return tempYMax;
  };

  isDataTruncated = () => {
    let tempDataIsTruncated = false;

    // TODO: Use the flag from the server instead of this hack
    if (this.props.list[0].rows.length === this.state.maxRecords) {
      tempDataIsTruncated = true;
    }
    return tempDataIsTruncated;
  };

  getSeriesName = () => {
    if (!this.props.list[1]) {
      return null;
    }
    let tempSeriesName = null;
    tempSeriesName = this.props.list[1].name;
    return tempSeriesName;
  };

  getSeriesUnit = () => {
    if (!this.props.list[1]) {
      return null;
    }
    let tempSeriesUnit = null;
    tempSeriesUnit = this.props.list[1].unit;
    return tempSeriesUnit;
  };

  getCustomYTickValues = () => {
    if (!this.props.list[1]) {
      return null;
    }
    const tempCustomYTickValues = [];
    _.each(this.props.list[1].plotting_advice.yaxis_markers, value => {
      tempCustomYTickValues.push(value[0]);
    });
    return tempCustomYTickValues;
  };

  getCustomYTickText = () => {
    if (!this.props.list[1]) {
      return null;
    }
    const tempCustomYTickText = [];
    _.each(this.props.list[1].plotting_advice.yaxis_markers, value => {
      tempCustomYTickText.push(value[1]);
    });
    return tempCustomYTickText;
  };

  getGraphAttributes = () => {
    if (!this.props.list) {
      return;
    }

    const attributeValues = {
      xMin: this.getXmin(this.isDataTruncated()),
      xMax: this.getXmax(),
      yMin: this.getYmin(),
      yMax: this.getYmax(),
      seriesUnit: this.getSeriesUnit(),
      seriesName: this.getSeriesName(),
      dataIsTruncated: this.isDataTruncated()
    };

    return attributeValues;
  };

  getGraphData = (xMin, xMax) => {
    const tempTimestamps = [];
    const tempValues = [];
    let tempData = {};

    if (this.props.list) {
      // FIXME: Find out why `this.props.list[1]` can be undefined.
      if (this.props.list[1] && this.props.list[1].rows.length > 0) {
        for (let i = 0; i < this.props.list[0].rows.length; i++) {
          tempTimestamps.push(this.props.list[0].rows[i]);
          tempValues.push(this.props.list[1].rows[i]);
        }
      } else {
        tempTimestamps.push(xMin);
        tempTimestamps.push(xMax);
      }
    }

    tempData = {
      timestamps: tempTimestamps,
      values: tempValues
    };

    return tempData;
  };

  checkAllTimeStampIsSame = value => {
    if (!value) {
      return null;
    }

    for (let i = 0; i < value.length; i++) {
      const compareDate = new Date(value[0]);
      const newDate = new Date(value[i]);
      if (newDate.getTime() !== compareDate.getTime()) {
        return false;
      }
    }
    return true;
  };

  getAlertBarData = () => {
    if (!this.props.sensorDataList || !this.props.list || !this.props.list[1]) {
      return null;
    }

    if (!this.state.alertsListForThisDevice && !this.props.list[1]) {
      return null;
    }

    const telemetry_type = this.props.sensorDataList[0].telemetry_type;
    const series_id = this.props.list[1].id;
    const foundAlertItem = [];
    const tempAlertBarData = [];

    _.each(this.state.alertsListForThisDevice, value => {
      if (
        value.telemetry_sets[0].telemetry_type_id === telemetry_type &&
        value.telemetry_sets[0].series_id === series_id
      ) {
        foundAlertItem.push(value);
      }
    });

    _.each(foundAlertItem, value => {
      tempAlertBarData.push({
        start: value.telemetry_start_time,
        end: value.telemetry_end_time,
        name: value.alert_type.name
      });
    });

    return tempAlertBarData;
  };

  getAlertTraceData = () => {
    if (!this.props.sensorDataList || !this.props.list || !this.props.list[1]) {
      return null;
    }

    if (!this.props.telemetryAlertDataList && !this.props.list[1]) {
      return null;
    }

    const telemetry_type = this.props.sensorDataList[0].telemetry_type;
    const series_id = this.props.list[1].id;
    const foundAlertItem = [];
    const tempAlertData = [];

    _.each(this.props.telemetryAlertDataList, value => {
      if (value.monitored_telemetry_type === telemetry_type && value.monitored_series_id === series_id) {
        foundAlertItem.push(value);
      }
    });

    _.each(foundAlertItem, value => {
      if (value.columns[1].rows.length > 0) {
        const tempTimestamps = [];
        const tempValues = [];

        let lastThreshold = null;

        for (let i = 0; i < value.columns[1].rows.length; i++) {
          const timestamp = this.toLocal(value.columns[0].rows[i]);
          const threshold = value.columns[1].rows[i];

          if (lastThreshold !== null && threshold === null) {
            tempTimestamps.push(timestamp);
            tempValues.push(lastThreshold);
          }

          tempTimestamps.push(timestamp);
          tempValues.push(threshold);

          lastThreshold = threshold;
        }

        const alertLineType = this.checkAllTimeStampIsSame(tempTimestamps);

        tempAlertData.push({
          timestamps: tempTimestamps,
          values: tempValues,
          severity: value.alert_type.severity,
          name: value.alert_type.name,
          lineType: alertLineType
        });
      }
    });

    return tempAlertData;
  };

  createAlertLines = alertData => {
    const alertLines = [];

    _.each(alertData, value => {
      const tempAlertObj = {
        type: "scatter",
        mode: "lines",
        x: value.timestamps,
        y: value.values,
        line: {
          shape: "hv",
          width: 0.5,
          color: alertingColors[value.severity],
          dash: "dashdot"
        },
        name: value.name
      };
      alertLines.push(tempAlertObj);
    });

    return alertLines;
  };

  createAlertBarGraphs = (alertBarData, attributeValue) => {
    const alertBarGraphs = [];

    _.each(alertBarData, value => {
      const tempAlertBarObj = {
        type: "rect",
        xref: "x",
        yref: "paper",
        x0: value.start,
        y0: attributeValue.yMin,
        x1: value.end,
        y1: attributeValue.yMax,
        fillcolor: "rgba(0,186,212,0.08)",
        line: {
          width: 0.5,
          color: "rgba(0,186,212,0.3)"
        },
        name: value.name
      };
      alertBarGraphs.push(tempAlertBarObj);
    });

    return alertBarGraphs;
  };

  toLocal = timestamp => {
    return moment(timestamp).format();
  };

  renderGraphData = (data, attributes, alerts) => {
    // Convert timestamps to the local timezone (Plotly has no timezone support)
    const timestamps = data.timestamps.map(this.toLocal);

    if (data.values.length > 0) {
      const tempGraphDataArray = [];

      const sensorData = {
        type: "scatter",
        mode: "lines",
        x: timestamps,
        y: data.values,
        line: { width: 1.5 },
        name: attributes.seriesName
      };

      const alertData = this.createAlertLines(alerts);

      tempGraphDataArray.push(sensorData);

      _.each(alertData, value => {
        tempGraphDataArray.push(value);
      });

      return tempGraphDataArray;
    } else {
      return [
        {
          x: timestamps,
          y: [-1, -1],
          hoverinfo: "none"
        }
      ];
    }
  };

  render = () => {
    const { sidebarOnFlag, list } = this.props;
    const attributeValue = this.getGraphAttributes();

    if (!(attributeValue !== undefined)) {
      return null;
    }

    const alertData = this.getAlertTraceData();
    const alertBarData = this.getAlertBarData();
    const graphData = this.getGraphData(attributeValue.xMin, attributeValue.xMax);
    const alertBarGraph = this.createAlertBarGraphs(alertBarData, attributeValue);
    // NOTE: This is caused by an unknown bug which sometimes causes plotting data missing(`undefined`).
    // And when there is actually no data available, the plotting data won't be `undefined` but contain basic fields.
    const isPlottingDataProvided = Boolean(list[1]);

    return (
      <div className="outer-con">
        <Plot
          style={{
            width: "100%",
            height: this.props.height
          }}
          data={this.renderGraphData(graphData, attributeValue, alertData)}
          layout={{
            shapes: alertBarGraph,
            autosize: true,
            showlegend: false,
            margin: {
              l: 50,
              r: 50,
              b: 50,
              t: 10,
              pad: 8
            },
            yaxis: {
              title: attributeValue.seriesName + " (" + attributeValue.seriesUnit + ")",
              showline: false,
              range: [attributeValue.yMin, attributeValue.yMax],
              color: "#888888",
              zerolinecolor: "#dddddd",
              fixedrange: true,
              automargin: true,
              tickprefix: "  ",
              titlefont: {
                size: 11
              },
              tickvals: (isPlottingDataProvided && list[1].plotting_advice.yaxis_markers) ? this.getCustomYTickValues() : null,
              ticktext: (isPlottingDataProvided && list[1].plotting_advice.yaxis_markers) ? this.getCustomYTickText() : null
            },
            xaxis: {
              range: [attributeValue.xMin, attributeValue.xMax],
              color: "#888888",
              zerolinecolor: "#dddddd",
              showline: false,
              fixedrange: true
            }
          }}
          config={{
            displaylogo: false,
            modeBarButtonsToRemove: [
              "sendDataToCloud",
              "select2d",
              "lasso2d",
              "hoverClosestCartesian",
              "hoverCompareCartesian",
              "toggleSpikelines"
            ]
          }}
          useResizeHandler={true}
          onUpdate={function(graphDiv) {
            // Initial ranges don't get reset when the graph updates,
            // causing problems when changing filter parameters then
            // trying to reset zoom levels. This callback makes sure
            // that the initial ranges get updated whenever the graph
            // changes.
            graphDiv._fullLayout.xaxis._rangeInitial = [attributeValue.xMin, attributeValue.xMax];
            graphDiv._fullLayout.yaxis._rangeInitial = [attributeValue.yMin, attributeValue.yMax];
          }}
        />
        {sidebarOnFlag === false ? (
          graphData.values.length > 0 ? null : (
            <div
              className="noData"
              style={{
                width: "100%",
                height: this.props.height
              }}
            >
              <div className="centerDiv">
                <h3>No Data Available</h3>
                {isPlottingDataProvided ? (
                  <p>
                    No telemetry was found for the period selected. Consider expanding your search range or select another
                    telemetry type.
                  </p>
                ) : <p>Please refresh the page or click filter again to get graph data.</p>}
              </div>
            </div>
          )
        ) : null}
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { id, sensorDataList } = state.sensordata;
  const { list } = state.filteredSensorData;
  const { telemetryAlertDataList } = state.telemetryAlertData;
  const { sidebarOnFlag } = state.sidebar;
  const { user } = state.authentication;
  return {
    list,
    id,
    user,
    sidebarOnFlag,
    sensorDataList,
    telemetryAlertDataList
  };
}

export default connect(
  mapStateToProps,
  { getSensorData, filteredSensorDataList, modalAlert }
)(LineGraph);



// WEBPACK FOOTER //
// ./src/_components/LineGraph/index.js